$(document).ready(function() {

    // nur wenn eine Forward-URL pro Projekt hinterlegt ist
    var forwardUrl = $('#ttgForwardUrl').attr('data-forwardUrl');

    if (forwardUrl && forwardUrl.length > 0) {

        $("a.ttgWebsiteLink").click(function(e) {

            var pattern = /^(http:\/\/)/;
            var targetObj = $(this);
            var targetURL = targetObj.attr('href');
            var hash = targetObj.data('hash');

            if (targetObj.attr('target') == "_blank" && pattern.test(targetURL)) {
                e.preventDefault();
            }
            // wenn es sich um eine HTTP URL handelt, soll der Link über den Forwarder aufgerufen werden
            if (pattern.test(targetURL)) {
                window.open(forwardUrl + "?url=" + targetURL + "&hash=" + hash);
            }

        });
    }

});